module.exports = __webpack_public_path__ + "static/media/qrcode.253d6348.svg";